import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import Head from 'next/head';
import type { AdItem } from '@sbt-web/network/types';
import SocialMeta from '@/client/components/SEO/DetailHeadTags/SocialMeta';
import schemaOrg from '@/shared/tools/seo/detail';
import { ImgObjSchemaAdDetail } from '@/tools/seo/ImgObjSchema/AdDetail';
import { getDescription } from './utils';
type Props = {
  ad: AdItem;
  pageTitle: string;
};
export const AdDetailHeadTags: FC<Props> = t0 => {
  const $ = _c(23);
  const {
    ad,
    pageTitle
  } = t0;
  let t1;
  if ($[0] !== pageTitle) {
    t1 = <title key="page-title">{pageTitle}</title>;
    $[0] = pageTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ad) {
    t2 = getDescription(ad);
    $[2] = ad;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <meta name="description" key="description" content={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <meta name="robots" key="robots" content="index, follow, max-image-preview:large" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== ad.urls.default) {
    t5 = <link rel="canonical" key="canonical-url" href={ad.urls.default} />;
    $[7] = ad.urls.default;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ad) {
    t6 = schemaOrg(ad);
    $[9] = ad;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <script key="detail-schema" {...t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] !== ad) {
    t8 = <ImgObjSchemaAdDetail adItem={ad} />;
    t9 = SocialMeta({
      adItem: ad
    });
    $[13] = ad;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <Head>{t1}{t3}{t4}{t5}{t7}{t8}{t9}</Head>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};